const routes = {
  ARTICLE_DISPLAY: '/article',
  CONSULTATION_VIDEO_APPOINTMENT: '/consultation_video_appointment',
  CONSULTATION_LIVE_VIDEO: '/consultation_live_video',
  CONSULTATION_START_FLOW: '/consultation_start_flow',
  CONSULTATION_CHAT: '/consultation_chat',
  CONSULTATIONS_COMPLETED: '/consultations_completed',
  PET_DETAILS: '/pet_details',
  PET_ADD: '/pet_add',
  HOME: '/home',
  WEB_LANDING: '/web_landing',
  SIGN_IN: '/sign_in',
  SIGN_UP: '/sign_up',
  LANDING: '/landing',
  PET_LIST: '/pet_list',
  SETTINGS_CHANGE_PASSWORD: '/settings_change_password',
  SETTINGS_CHANGE_PAYMENT: '/settings_change_payment',
  SETTINGS_CHANGE_PHONE_NUMBER: '/settings_change_phone_number',
  SETTINGS_CONTACT_SUPPORT: '/settings_contact_support',
  SETTINGS: '/settings',
  SETTINGS_USER_PROFILE: '/settings_user_profile',
  SETTINGS_MANAGE_SUBSCRIPTION: '/settings_manage_subscription',
  EMPTY_PAGE: '/empty_page'
}

export default routes
